import PostPageDesktop from './post-page-desktop';
import PostPageMobile from './post-page-mobile';
import forDevice from '../../hoc/for-device';

export default forDevice(PostPageMobile, PostPageDesktop);
